export { gfmAutolinkLiteral } from './lib/syntax.js';
export { gfmAutolinkLiteralHtml } from './lib/html.js';